import {
	NEGATIVE_CHIP,
	NEUTRAL_CHIP,
	ACTIVE_CHIP,
} from '../mixins/style/chip-mixins';

export enum ContactProfileStatusCode {
	pending = 'pending',
	underReview = 'underReview',
	approved = 'approved',
	active = 'active',
	inactive = 'inactive',
	rejected = 'rejected',
	expired = 'expired',
	suspended = 'suspended',
	withdrawn = 'withdrawn',
	cancelled = 'cancelled',
	terminated = 'terminated',
}

export enum ContactProfilePaymentStatusCode {
	unpaid = 'unpaid',
	paid = 'paid',
	refunded = 'refunded',
	partiallyRefunded = 'partiallyRefunded',
	waived = 'waived',
	free = 'free',
	failed = 'failed',
	incomplete = 'incomplete',
}

export enum ContactSearchField {
	contactIdOrName = 'contactIdOrName',
	name = 'name',
	email = 'email',
	phone = 'phone',
	fullNameChi = 'fullNameChi',
	firstNameEng = 'firstNameEng',
	lastNameEng = 'lastNameEng',
	profileCode = 'profileCode',
}

export const ContactProfilePaymentStatusChipStyle = {
	[ContactProfilePaymentStatusCode.paid]: ACTIVE_CHIP,
	[ContactProfilePaymentStatusCode.waived]: ACTIVE_CHIP,
	[ContactProfilePaymentStatusCode.free]: ACTIVE_CHIP,
	[ContactProfilePaymentStatusCode.unpaid]: NEUTRAL_CHIP,
	[ContactProfilePaymentStatusCode.refunded]: NEGATIVE_CHIP,
	[ContactProfilePaymentStatusCode.partiallyRefunded]: ACTIVE_CHIP,
	[ContactProfilePaymentStatusCode.failed]: NEGATIVE_CHIP,
	[ContactProfilePaymentStatusCode.incomplete]: NEGATIVE_CHIP,
};

export const ContactProfileStatusChipStyle = {
	[ContactProfileStatusCode.active]: ACTIVE_CHIP,
	[ContactProfileStatusCode.underReview]: NEUTRAL_CHIP,
	[ContactProfileStatusCode.pending]: NEUTRAL_CHIP,
	[ContactProfileStatusCode.approved]: ACTIVE_CHIP,
	[ContactProfileStatusCode.inactive]: NEGATIVE_CHIP,
	[ContactProfileStatusCode.rejected]: NEGATIVE_CHIP,
	[ContactProfileStatusCode.expired]: NEGATIVE_CHIP,
	[ContactProfileStatusCode.suspended]: NEGATIVE_CHIP,
	[ContactProfileStatusCode.withdrawn]: NEGATIVE_CHIP,
	[ContactProfileStatusCode.cancelled]: NEGATIVE_CHIP,
	[ContactProfileStatusCode.terminated]: NEGATIVE_CHIP,
};

export interface ContactSearchCondition {
	field: ContactSearchField;
	value: string;
}

export interface SearchByAppUserIdCondition {
	appUserId: string;
}
